import styled from 'styled-components/macro';
import { Image, ImageStyled } from '@yme/atoms/image';
import { MiniButton, MiniButtonContent } from '@yme/atoms/mini-button';
import { colorBlackTransparent50 } from '@yme/tokens/colors';
import { RegularTextLevel3 } from '@yme/tokens/typography';
import { getTextStyles } from '@yme/utils/styles';
export const ImageWrapperStyled = styled(Image) `
  ${ImageStyled} {
    object-fit: cover;
    object-position: center;
    background: ${colorBlackTransparent50};

    aspect-ratio: ${({ aspectRatio }) => aspectRatio};
  }
  width: 100%;
  cursor: pointer;
`;
export const ContentStyled = styled(RegularTextLevel3) `
  display: -webkit-box;
  -webkit-line-clamp: ${({ countLineVisible = 4 }) => countLineVisible};
  -webkit-box-orient: vertical;
  overflow: hidden;
`;
export const MiniButtonStyled = styled(MiniButton) `
  ${MiniButtonContent} {
    ${getTextStyles(null, null, 16, 24)}
  }
`;
export const ForOwnersWrapper = styled.div `
  margin-bottom: ${({ marginBottom }) => marginBottom};
`;
